import { LuMaximize, LuMinimize } from 'react-icons/lu';
import { Button } from '~/components/ui/button';
import { useFullscreen } from '~/hooks/useFullscreen';

export function FullscreenButton() {
    const { isFullscreen, toggleFullscreen } = useFullscreen();

    return (
        <Button preset="secondary" icon={isFullscreen ? <LuMinimize /> : <LuMaximize />} onClick={toggleFullscreen} />
    );
}
